<template>
    <!-- <q-scroll-area id="scroll" class="passage__scroll"> -->
    <div>
        <h6 class="template__title">
            <div class="display_flex" style="align-items: end">
                <AnswerMarking :marking-class="markingClass" />
            </div>
        </h6>
        <div> 
            <div v-html="question"></div> 
            <!-- <v-runtime-template :template="question"></v-runtime-template> -->
            <div class="row" style="width: 100%">
                <q-radio
                    v-if="choiceArrange"
                    v-for="(item, index) in choiceArrange.data"
                    :class="'col-' + 12 / (choiceArrange.array === '0' ? 1 : Number(choiceArrange.array))"
                    style="padding: 10px"
                    v-model="choice"
                    :val="item.numChar"
                    v-bind:class="onResult(item)"
                    @update:model-value="onChangeAnswer"
                    :disable="props.pContent.result && props.pContent.result.marking !== 'halfWrong'"
                >
                    <div class="display_flex" style="width: 100%">
                        <div class="display_flex" style="justify-content: center; align-items: center; margin-right: 10px">
                            <div class="item-num">
                                {{ item.num }}
                            </div>
                        </div>

                        <div v-html="item.text"></div>
                    </div>
                </q-radio>
            </div>
        </div>
    </div>
    <!-- </q-scroll-area> -->
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineEmits, defineProps, watch, toRaw } from 'vue';
import { getQuestion_old, getChoice } from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import VRuntimeTemplate from 'vue3-runtime-template';
import AnswerMarking from '@/components/qbank/answerMarking.vue';
import { difficult, drill } from '@/helpers/qbankParser/qbankMeta';

import { useRouter, useRoute } from 'vue-router';
const route = useRoute();

const question = ref('');
const choiceArrange = ref([]);
const choice = ref('');
const rightAnswer = ref(null);
const isDisableBtn = ref(true);

let markingClass = '';
let drillChip = ref([]);

const emit = defineEmits(['setAnswer']);
// const $q = useQuasar();

const props = defineProps({
    pContent: {
        default: {},
    },
    unitNo: {
        Type: Number,
        default: -1,
    },
    isStudy: {
        Type: Boolean,
        default: false,
    },
    // isOriginal: {
    //     Type: Boolean,
    // },
});

const onChangeAnswer = (v, evt) => {
    // if (!props.isStudy) emit('setAnswer', v);
    emit('setAnswer', v);
};

// set Class
const onResult = (item) => {
    if (props.isStudy) {
    }
    const c = rightAnswer.value;
    // console.log('--onResult--c:', c);
    return c !== null && c === item.numChar ? 'item-correct' : item.numChar === choice.value ? 'item-select' : 'item-nomal';
};

// watch(props.unitNo, (newUnitNo) => {});

watch(
    () => props.pContent,
    (newValue) => {
        // const questionHeader = JSON.parse(JSON.stringify(newValue));
        const vContent = toRaw(newValue);
        // parsingContent(vContent.data.content);
        // console.log(vContent.data);
        // question.value = getQuestion_old(vContent.data);

        const parseQuestion = getQuestion_old(vContent.data);
        addUnitNo(parseQuestion);
        choiceArrange.value = getChoice(vContent.data);
        // console.log('vContent.answer $$$$$$$$$$$$$$$$$$$$$$$$$$$$$');
        // console.log(vContent.answer);
        rightAnswer.value = null;
        if (vContent.reAnswer) {
            choice.value = vContent.reAnswer;
        } else if (vContent.answer) {
            choice.value = vContent.answer;
        } else {
            choice.value = '';
        }
        if (vContent.result) {
            markingClass = 'marking-' + vContent.result.marking;
            if (vContent.result.marking !== 'halfWrong') {
                setTimeout(() => {
                    const item = document.querySelectorAll('.input_answers');
                    item.forEach((target) => {
                        target.setAttribute('readonly', true);
                    });
                }, 200);
                rightAnswer.value = vContent.data.content.solution.answer.detail[0].answer;
                // console.log('--rightAnswer--', rightAnswer.value);
            }
        } else {
            markingClass = '';
        }

        drillChipsInit(vContent);
    },
);

onMounted(() => {
    const vContent = toRaw(props.pContent);
    // console.log('----problemChoice--vContent--', vContent);
    const parseQuestion = getQuestion_old(vContent.data);
    addUnitNo(parseQuestion);
    // question.value = parseQuestion.replace('>', `><span style="font-size:15.6px;" >${props.unitNo}. </span>`);
    choiceArrange.value = getChoice(vContent.data);

    if (vContent.answer && vContent.answer.length > 0) {
        vContent.answer.map((i) => {
            setTimeout(() => {
                document.getElementById('choiceList_' + i).checked = true;
            }, 100);
        });
    }
    drillChipsInit(vContent);
});

// 문제번호 삽입하기
const rrHtml = (text, pick, replace) => (text.includes(pick) ? text.replace(pick, replace) : text);
const addUnitNo = (parseQuestion) => {
    question.value = parseQuestion;
};

const drillChipsInit = (vContent) => {
    drillChip.value = [];
    if (vContent.questionClass === 'DRILL_DOWN') {
        for (var a = Number(vContent.baseDifficult); a > Number(vContent.etcInfo.difficultCd); a--) {
            drillChip.value.push({
                label: difficult['0' + a].label,
                drill: 'down',
            });
        }
    }
    if (vContent.questionClass === 'DRILL_UP') {
        for (var a = Number(vContent.baseDifficult); a < Number(vContent.etcInfo.difficultCd); a++) {
            drillChip.value.push({
                label: difficult['0' + a].label,
                drill: 'up',
            });
        }
    }
};

onUnmounted(() => {
    drillChip.value = [];
});
</script>

<style lang="scss" scoped>
.template {
    &__no {
        margin: 0px 13px;
    }
}

::v-deep input {
    // width: 500px;
    // height: 32px;
    // font-size: 15px;

    border: 1px solid rgb(233, 233, 233);
    border-radius: 5px;
    outline: none;
    margin: 0px 5px;
    text-align: center;
    max-width: 100%;
}

::v-deep textarea {
    // width: 500px;
    // height: 32px;
    // font-size: 15px;

    border: 1px solid rgb(233, 233, 233);
    border-radius: 5px;
    outline: none;
    margin: 0px 5px;
    max-width: 100%;
}

::v-deep p {
    margin: 0px;
}

.radio {
    &__wrap {
        grid-template-columns: repeat(2, size(120));
        grid-template-rows: repeat(2, size(120));
    }
}

.direction__frame {
    border: 1px solid;
    padding: 10px;
    font-size: size(12);
}

.distracter {
    margin-top: size(16);
    counter-reset: number;

    .checkbox {
        display: block;
        position: relative;
        width: 100%;
        min-height: size(55);
        margin-bottom: size(20);
        background: white;
        border-radius: size(10);
        border-bottom: size(5) solid #eef3f5;
        box-shadow: 0 size(1) size(5) 0 rgba(64, 87, 1, 0.15);
        font-size: size(17);
        font-weight: 500;

        &__wrap {
            &.arrange2 {
                display: flex;
                flex-wrap: wrap;
                margin: size(-10);

                .checkbox {
                    width: calc(100% / 2 - #{size(20)});
                    margin: size(10);
                }
            }

            &.arrange3 {
                display: flex;
                flex-wrap: wrap;
                margin: size(-10);

                .checkbox {
                    width: calc(100% / 3 - #{size(20)});
                    margin: size(10);
                }
            }

            &.horizontal {
                display: flex;
                margin: size(-10);

                .checkbox {
                    margin: size(10);
                }
            }

            .card-item {
                margin-right: 10px;
                @include center-element;
            }
        }

        &__label {
            // display: block;
            display: inline-flex;
            align-items: center;
            position: relative;
            width: 100%;
            // padding: size(16) size(10) size(16) size(32);
            padding: size(16) size(10) size(16) size(10);
            min-height: size(55);
            line-height: 1.31;
            background: white;
            border-radius: size(10);

            &:before {
                // counter-increment: number;
                // content: counter(number);
                display: inline-flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: size(16);
                left: size(10);
                width: size(14);
                height: size(14);
                margin-right: size(5);
                border: size(1) solid #000;
                border-radius: 100%;
                font-size: size(12);

                & + u {
                    margin-left: 0;
                }
            }
        }

        input {
            display: none;

            &:checked {
                & + .checkbox__label {
                    box-sizing: border-box;

                    &:after {
                        content: '';
                        display: block;
                        width: 100%;
                        height: 100%;
                        border: size(2.5) solid #3a3a3a;
                        position: absolute;
                        left: 0;
                        top: 0;
                        box-sizing: border-box;
                        border-radius: 9px;
                    }

                    &.correct {
                        border-color: #00a7ff;
                        color: #00a7ff;

                        &:before,
                        &:after {
                            border-color: #00a7ff;
                            color: #00a7ff;
                        }

                        ::v-deep u {
                            color: #00a7ff;
                        }
                    }

                    &.wrong {
                        border-color: #ff0000;
                        color: #ff0000;

                        &:before,
                        &:after {
                            border-color: #ff0000;
                            color: #ff0000;
                        }

                        ::v-deep u {
                            color: #ff0000;
                        }
                    }
                }
            }
        }
    }
}

.template {
    .direction {
        &__thumb {
            padding: size(12.5) 0;
            border: none;
        }

        &__textbox {
            line-height: 1.4;

            ::v-deep > div {
                min-height: size(17);
            }
        }
    }
}

::v-deep .textbox_inputImg {
    vertical-align: middle;
}

.disableTouch {
    touch-action: none;
    pointer-events: none;
}

::v-deep .q-radio__inner {
    display: none;
}

::v-deep .item {
    &-nomal {
        // background-color: #efefef;
        border-radius: 10px;

        .item-num {
            border-radius: 20px;
            border: 1px solid #bdbdbd;
            color: #bdbdbd;
            padding: 0px 8px 2px;
        }
    }

    &-select {
        // background-color: #efefef;
        border-radius: 10px;

        .item-num {
            border-radius: 20px;
            border: 1px solid #4659ff;
            background-color: #4659ff;
            color: white;
            padding: 0px 8px 2px;
        }
    }

    &-correct {
        // background-color: #d7eaff;
        border-radius: 10px;

        .item-num {
            border: 1px solid #118af1;
            background-color: #118af1;
            color: white;
            border-radius: 20px;
            padding: 0px 8px 2px;
        }
    }

    &-wrong {
        // background-color: #ffc8d6;
        border-radius: 10px;

        .item-correct_num {
            border: 1px solid #fc6a8f;
            background-color: #fc6a8f;
            border-radius: 20px;
            padding: 0px 8px 2px;
        }
    }
}
</style>
